"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingRow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const grid_1 = require("antd/es/grid");
exports.LandingRow = (_a) => {
    var { revertOrder, leftSlot, rightSlot } = _a, rowProps = tslib_1.__rest(_a, ["revertOrder", "leftSlot", "rightSlot"]);
    const leftXs = revertOrder ? 0 : 24;
    const rightXs = revertOrder ? 24 : 0;
    return (React.createElement(grid_1.Row, Object.assign({ type: 'flex', align: 'middle' }, rowProps),
        React.createElement(grid_1.Col, { xs: leftXs, md: 12 }, leftSlot),
        React.createElement(grid_1.Col, { xs: rightXs, md: 12 }, rightSlot)));
};
//# sourceMappingURL=LandingRow.js.map